import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { BaseRichService } from '../../../providers/base-rich.service';
import { BaseListComponent } from '../../shared/base-list/base-list.component';
import { BaseUserListComponent } from '../base-user-list/base-user-list.component';

@Component({
  selector: 'app-voip-usages',
  templateUrl: '../../shared/base-list/base-list.component.html',
  styleUrls: ['./voip-usages.component.css', '../../shared/base-list/base-list.component.scss']
})
export class VoipUsagesComponent extends BaseUserListComponent implements OnInit, OnChanges {

  constructor(
    public cookieService: CookieService,
    public activeModal: NgbModal,
    public titleService: Title,
    public translator: TranslateService,
    public service: BaseRichService,
  ) {
    super(cookieService, activeModal, titleService, translator, service);
    this.entity = 'voip_usage';
    this.title = 'usage_report';
  }

  getBody(): any {
    const body = super.getBody();
    if (body.query) {
      body.query = [body.query, 'and', ['username', '=', this.userid]];
    } else {
      body.query = ['username', '=', this.userid];
    }
    return body;
  }

}
